import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

export const initialValuesFunctions = {
  code: '',
  description: '',
  entity: '',
  orders: {},
  page: 0,
  rowsPerPage: 10,
};

const PageFunctions = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValuesFunctions}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageFunctions.displayName = 'Page circulation areas initializer component';

export default PageFunctions;
